module.exports = __webpack_public_path__ + "static/img/contact_us_main.b781361.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/pc/contact_us_main.png
// module id = MHvh
// module chunks = 1